/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */

export default function () {

    var className = "navbar-ontop"

    // we start hidden, to avoid flickering
    document.write("<style id='temp-navbar-ontop'>.navbar {opacity:0; transition: none !important}</style>")

    var cartFooter = $('.fixed-bottom');

    function update() {
        // toggle className based on the scrollTop property of document
        var nav = document.querySelector(".navbar");

        if ($(cartFooter).length){
            cartFooter.show();
        }

        if (window.scrollY > 50)
            nav.classList.remove(className)
        else
            nav.classList.add(className)
    }



    document.addEventListener("DOMContentLoaded", function(event) {
        $(window).on('show.bs.collapse', function (e) {
            if ($(cartFooter).length){
                cartFooter.hide();
            }
            // removed due to silly x jump
            //$(e.target).closest("." + className).removeClass(className);
        })

        $(window).on('hidden.bs.collapse', function (e) {
            update()
        })
        update()
        // still hacking to avoid flickering
        setTimeout(function() {
            $("#temp-navbar-ontop").remove();
        })
    });

    window.addEventListener("scroll", function() {
        update()
    })

}
